var ScrollButton = require("enyo-ui/ScrollButton"),
    SvgIcon      = require("app/ui/SvgIcon"),
    kind         = require("enyo/kind");

require("app/ui/ScrollButton.less");

module.exports = kind(/** @lends  app.ui.ScrollButton.prototype */ {

    /**
     * @private
     */
    name: "app.ui.ScrollButton",

    /**
     * @private
     */
    kind: ScrollButton,

    /**
     * @private
     */
    classes: "app-ui-scroll-button",

    /**
     * The id used to reference an icon from the icon-sprite.
     *
     * @type {?string}
     * @public
     */
    icon: null,

    /**
     * The text that will display as tooltip and is used by screen readers.
     *
     * @type  {?string}
     * @public
     */
    tooltip: null,

    /**
     * @private
     */
    components: [{
        name:    "icon",
        kind:    SvgIcon,
        classes: "app-ui-scroll-button__icon enyo-fit"
    }],

    /**
     * @private
     */
    bindings: [{
        from: ".icon",
        to:   ".$.icon.icon"
    }],

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.tooltipChanged();
        };
    }),

    /**
     * Set css flag in case of no icon
     *
     * @private
     */
    tooltipChanged: function() {
        this.setAttribute("title", this.get("tooltip") || null);
    }

});
